"use client";

import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function TheSignatureLook() {
  const {
    ref: leftRef,
    isVisible: leftVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const {
    ref: rightRef,
    isVisible: rightVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  return <section data-section-id="380" id="the-signature-look" className="bg-background text-foreground relative overflow-hidden">
      <div className="grid grid-cols-1 lg:grid-cols-12 min-h-screen lg:min-h-[90vh]">
        {}
        <div ref={leftRef} className={`order-2 lg:order-1 lg:col-span-5 relative flex flex-col justify-center px-6 sm:px-10 lg:px-14 py-16 lg:py-20 transition-all duration-1000 ease-out ${leftVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          {}
          <div aria-hidden="true" className="pointer-events-none absolute -top-20 -left-20 w-72 h-72 rounded-lg opacity-20 blur-3xl" style={{
          background: "radial-gradient(circle at center, var(--chart-4), transparent 70%)"
        }} />

          {}
          <div className="relative z-10 mb-8 lg:mb-10">
            <span className="font-default text-[11px] sm:text-xs tracking-[0.25em] uppercase font-medium" style={{
            color: "var(--chart-1)"
          }}>Est. 2010 · Belleza Editorial</span>
            <span className="inline-block w-12 h-px ml-4 align-middle" style={{
            background: "var(--chart-1)"
          }} />
          </div>

          {}
          <h1 className="font-serif font-light text-foreground relative z-10" style={{
          fontSize: "clamp(3rem, 7vw, 7rem)",
          lineHeight: "0.95",
          letterSpacing: "-0.02em"
        }}>
            Belleza editorial,
            <br />
            diseñada{" "}
            <em className="italic font-medium" style={{
            color: "var(--chart-1)"
          }}>
              a medida
            </em>
            .
          </h1>

          {}
          <p className="mt-8 lg:mt-10 text-base sm:text-lg leading-relaxed text-foreground/75 max-w-[380px] relative z-10" style={{
          fontFamily: "var(--font-serif)"
        }}>
            Artistry profesional de cabello y maquillaje para sesiones de modelos y ocasiones especiales, diseñado según tus características únicas en Valencia y Madrid.
          </p>

          {}
          <div className="mt-10 lg:mt-12 flex flex-col sm:flex-row gap-4 relative z-10">
            <Button asChild size="lg" className="px-7 h-12 bg-primary text-primary-foreground hover:bg-primary/90 font-default tracking-wide">
              <Link to="/BookingPage">Reserva Ahora</Link>
            </Button>

            <Button asChild variant="ghost" size="lg" className="group px-7 h-12 border border-border bg-transparent hover:bg-accent/20 text-foreground font-default tracking-wide">
              <Link to="/PortfolioPage">
                Ver Portafolio
                <ArrowRight className="ml-1 size-4 transition-transform duration-300 group-hover:translate-x-1.5" />
              </Link>
            </Button>
          </div>

          {}
          <div className="mt-14 lg:mt-20 flex items-end gap-3 relative z-10">
            <svg width="44" height="56" viewBox="0 0 44 56" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" className="opacity-60 shrink-0">
              <path d="M22 54 C 22 40, 22 26, 22 4" stroke="currentColor" strokeWidth="1" strokeLinecap="round" />
              <path d="M22 14 C 14 12, 8 14, 6 20 C 12 22, 18 20, 22 16" stroke="currentColor" strokeWidth="1" strokeLinecap="round" fill="none" />
              <path d="M22 24 C 30 22, 36 24, 38 30 C 32 32, 26 30, 22 26" stroke="currentColor" strokeWidth="1" strokeLinecap="round" fill="none" />
              <path d="M22 36 C 16 34, 10 36, 9 41 C 14 43, 19 41, 22 38" stroke="currentColor" strokeWidth="1" strokeLinecap="round" fill="none" />
            </svg>
            <p className="italic text-sm text-foreground/55 leading-snug max-w-[220px]" style={{
            fontFamily: "var(--font-serif)"
          }}>
              Disponible con cita previa en Valencia y Madrid.
            </p>
          </div>
        </div>

        {}
        <div ref={rightRef} className={`order-1 lg:order-2 lg:col-span-7 relative min-h-[60vh] lg:min-h-full overflow-hidden transition-all duration-1000 ease-out ${rightVisible ? "opacity-100 scale-100" : "opacity-0 scale-105"}`}>
          <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1699048/img/niki_b_signature_look.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1699048/img/niki_b_signature_look.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1699048/img/niki_b_signature_look.png-wvc-sizes" alt="Signature editorial makeup look by Niki B. Makeup" loading="eager" decoding="async" className="absolute inset-0 w-full h-full object-cover" src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1699048/img/Screenshot-2026-06-09-151903.webp" src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1699048/img/ae9261ca-f07a-4353-a8a2-064606bdf890-scaled.png" src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1699048/img/ae9261ca-f07a-4353-a8a2-064606bdf890-scaled.png" src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1699048/img/ae9261ca-f07a-4353-a8a2-064606bdf890-scaled.png" src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1699048/img/ae9261ca-f07a-4353-a8a2-064606bdf890-scaled.png" src="https://nikibmakeup.com/wp-content/uploads/2026/06/ae9261ca-f07a-4353-a8a2-064606bdf890-scaled.jpg" />
          {}
          <div aria-hidden="true" className="absolute inset-0 lg:hidden" style={{
          background: "linear-gradient(to bottom, transparent 60%, var(--background) 100%)"
        }} />
        </div>

        {}
        <div className={`hidden lg:flex absolute z-20 top-1/2 -translate-y-1/2 items-center justify-center transition-all duration-1000 delay-300 ${leftVisible ? "opacity-100 rotate-[-8deg] scale-100" : "opacity-0 rotate-0 scale-75"}`} style={{
        left: "41.666%",
        transform: "translate(-50%, -50%) rotate(-8deg)"
      }}>
          <div className="relative w-32 h-32 xl:w-36 xl:h-36 flex items-center justify-center shadow-lg" style={{
          background: "var(--primary)"
        }}>
            {}
            <div className="absolute inset-2 border border-foreground/30" style={{
            borderRadius: "0"
          }} />
            <div className="text-center px-4">
              <p className="italic text-[10px] xl:text-[11px] leading-tight" style={{
              color: "var(--primary-foreground)",
              fontFamily: "var(--font-serif)"
            }}>
                Editorial
                <br />
                <span className="not-italic text-[8px] tracking-widest">·</span>
                <br />
                Profesional
                <br />
                <span className="not-italic text-[8px] tracking-widest">·</span>
                <br />
                Con Cita Previa
              </p>
            </div>
          </div>
        </div>

        {}
        <div className="lg:hidden absolute z-20 top-6 right-6">
          <div className="relative w-24 h-24 flex items-center justify-center shadow-lg rotate-[-8deg]" style={{
          background: "var(--primary)",
          borderRadius: "0"
        }}>
            <div className="absolute inset-1.5 border border-foreground/30" style={{
            borderRadius: "0"
          }} />
            <div className="text-center px-2">
              <p className="italic text-[9px] leading-tight" style={{
              color: "var(--primary-foreground)",
              fontFamily: "var(--font-serif)"
            }}>
                Editorial
                <br />
                Profesional
                <br />
                Con Cita Previa
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}